import { createAction, props } from '@ngrx/store';
import {
  ICartV2,
  IAddress,
  IOrder,
  IPaymentMethod,
  ICoupon,
  CheckoutOrderRequirementsChecks
} from '@care-portals/api-interfaces';

export const reloadCart = createAction('[CheckoutV2] Reload Cart');

export const loadCart = createAction(
  '[CheckoutV2] Load Cart',
  props<{ cartId: string }>()
);

export const loadCartSuccess = createAction(
  '[CheckoutV2] Load Cart Success',
  props<{ cart: ICartV2 }>()
);

export const loadCartFailure = createAction(
  '[CheckoutV2] Load Cart Failure',
  props<{ error: Error }>()
);

export const startCheckout = createAction(
  '[CheckoutV2] Start Checkout',
  props<{ cartId: string }>()
);

export const startCheckoutSuccess = createAction(
  '[CheckoutV2] Start Checkout Success',
  props<{ cart: ICartV2; paymentMethods: IPaymentMethod[] }>()
);

export const startCheckoutFailure = createAction(
  '[CheckoutV2] Start Checkout Failure',
  props<{ error: Error }>()
);

export const loadAddresses = createAction(
  '[CheckoutV2] Load Customer Addresses'
);

export const loadAddressesSuccess = createAction(
  '[CheckoutV2] Load Customer Addresses Success',
  props<{ addresses: IAddress[] }>()
);

export const loadAddressesFailure = createAction(
  '[CheckoutV2] Load Customer Addresses Failure',
  props<{ error: Error }>()
);

export const addAddress = createAction(
  '[CheckoutV2] Save Customer Addresses',
  props<{ address: IAddress }>()
);

export const addAddressSuccess = createAction(
  '[CheckoutV2] Save Customer Addresses Success',
  props<{ addresses: IAddress[] }>()
);

export const addAddressFailure = createAction(
  '[CheckoutV2] Save Customer Addresses Failure',
  props<{ error: Error }>()
);

export const finalizeCheckout = createAction(
  '[CheckoutV2] Finalize Checkout',
  props<{
    cartId: string;
    gateway: 'stripe' | 'nmi';
    couponCode: string;
  }>()
);

export const finalizeCheckoutSuccess = createAction(
  '[CheckoutV2] Finalize Checkout Success',
  props<{
    order: IOrder & CheckoutOrderRequirementsChecks;
  }>()
);

export const finalizeCheckoutFailure = createAction(
  '[CheckoutV2] Finalize Checkout Failure',
  props<{ error: Error }>()
);

export const setShippingAddress = createAction(
  '[CheckoutV2] Set Checkout Shipping IAddress',
  props<{ cartId: string; address: IAddress }>()
);

export const applyCoupon = createAction(
  '[CheckoutV2] Apply Coupon',
  props<{ code: string }>()
);

export const applyCouponSuccess = createAction(
  '[CheckoutV2] Apply Coupon Success',
  props<{
    cart: ICartV2;
    coupon: ICoupon;
  }>()
);

export const applyCouponFailure = createAction(
  '[CheckoutV2] Apply Coupon Failure'
);

export const setSelectedAddressIndex = createAction(
  '[CheckoutV2] Set Checkout Address Index',
  props<{ selectedAddressIndex: number | 'new' }>()
);

export const setNewAddress = createAction(
  '[CheckoutV2] Set Checkout New Address',
  props<{ address: IAddress }>()
);

export const setSelectedPaymentMethod = createAction(
  '[CheckoutV2] Set Checkout Selected Payment Method',
  props<{ paymentMethodId: string }>()
);

export const setCvv = createAction(
  '[CheckoutV2] Set Checkout CVV',
  props<{ value: string; showError: boolean }>()
);

export const nullAction = createAction('[CheckoutV2] Null');
